import styled from 'styled-components';

const Recognitions = styled.div`
  gap: 16px;
`;

const EmptyLine = styled.div`
  background: var(--color-fg-default);
  height: 1px;
  margin-left: 6px;
  width: 20px;
`;

const TableName = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 40px;
  text-decoration: underline;
  text-transform: capitalize;
  white-space: nowrap;

  &:hover {
    color: var(--color-accent-primary-default);
  }
`;

const ContactDetailHeader = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 16px;
`;

export { ContactDetailHeader, EmptyLine, Recognitions, TableName };
